import { defineMessages, FormattedMessage } from 'react-intl';
import React from 'react';

export const messages = defineMessages({
  title: {
    id: 'hubs.costs.financial-aid.title',
    defaultMessage: 'You may be eligible for financial aid.',
  },
  info: {
    id: 'hubs.costs.financial-aid.info',
    defaultMessage:
      'Merit-based scholarships are a form of aid that does not have to be repaid. This institution automatically considers incoming freshmen for merit-based scholarships on the criteria shown.',
  },
  infoUrlPrefix: {
    id: 'hubs.costs.financial-aid.info-url',
    defaultMessage: 'Learn about ',
  },
  infoUrlSuffix: {
    id: 'hubs.costs.financial-aid.info-url',
    defaultMessage: ' offered by this institution.',
  },
  infoUrl1: {
    id: 'hubs.costs.financial-aid.info-url1',
    defaultMessage: 'Learn about ',
  },
  infoUrl2: {
    id: 'hubs.costs.financial-aid.info-url2',
    defaultMessage: ' offered by this institution.',
  },
  thisCollege: {
    id: 'hubs.costs.this-college',
    defaultMessage: 'This college',
  },
  averageOfColleges: {
    id: 'hubs.costs.average-of-colleges',
    defaultMessage: 'Average of colleges in Naviance*',
  },
  averageOfCollegesNationally: {
    id: 'hubs.costs.average-of-colleges-nationally',
    defaultMessage: 'Average of colleges nationally*',
  },
  avgGrantAmount: {
    id: 'hubs.costs.average-grant-amount',
    defaultMessage: 'Average Grant Amount',
  },
  avgPellGrantAmount: {
    id: 'hubs.costs.average-pell-grant-amount',
    defaultMessage: 'Average Pell Grant Amount',
  },
  avgFedLoanAmount: {
    id: 'hubs.costs.average-fed-loan-amount',
    defaultMessage: 'Average Federal Student Loan Amount',
  },
  meritBasedScholarships: {
    id: 'hubs.costs.merit-based-scholarships',
    defaultMessage: 'Potential Merit-Based Scholarships',
  },
  grantInformation: {
    id: 'hubs.costs.grant-information',
    defaultMessage: 'Grant Information',
  },
  grantDescription: {
    id: 'hubs.costs.grant-description',
    defaultMessage:
      'Grants are a form of aid that does not have to be repaid. Grants are often awarded based on economic need.',
  },
  navianceCollegesNote: {
    id: 'hubs.costs.naviance-colleges',
    defaultMessage:
      '*4 Year schools that reported tuition & fee data to the U.S. Department of Education.',
  },
  pellGrantInformation: {
    id: 'hubs.costs.pell-information',
    defaultMessage: 'Pell Grant Information',
  },
  pellGrantDescription: {
    id: 'hubs.costs.pell-grant-description',
    defaultMessage: `A Federal Pell Grant is another form of aid that does not have to be repaid. Pell Grants usually are awarded only to undergraduate students who have not earned a bachelor's or a professional degree.`,
  },
  loanInformation: {
    id: 'hubs.costs.loan-information',
    defaultMessage: 'Loan Information',
  },
  loanDescription: {
    id: 'hubs.costs.loan-description',
    defaultMessage: `After applying for financial aid, you may be offered loans as part of your college's financial aid offer. A loan is money you borrow and must pay back with interest.`,
  },
  financialAidTooltip: {
    id: 'hubs.costs.merit-based-scholarships.financial-aid-tooltip',
    defaultMessage:
      'Financial aid in the U.S. helps students pay for post-secondary education, including tuition, fees and room and board. Aid also can help pay for transportation, books and supplies.',
  },
  bestMatchText: {
    id: 'hubs.costs.merit-based-scholarships.best-match-text',
    defaultMessage:
      'Based on your GPA, test scores, and class rank, you may be eligible for a merit scholarship of:',
  },
  bestMatchPerYear: {
    id: 'hubs.costs.merit-based-scholarships.best-match-per-year',
    // eslint-disable-next-line no-template-curly-in-string
    defaultMessage: '${amount} per year',
  },
  bestMatchOneTime: {
    id: 'hubs.costs.merit-based-scholarships.best-match-one-time',
    // eslint-disable-next-line no-template-curly-in-string
    defaultMessage: '${amount} One-time',
  },
  bestMatchFullTuition: {
    id: 'hubs.costs.merit-based-scholarships.best-match-full-tuition',
    defaultMessage: 'Full Tuition',
  },
  awardName: {
    id: 'hubs.costs.merit-based-scholarships.award-name',
    defaultMessage: 'AWARD NAME',
  },
  amount: {
    id: 'hubs.costs.merit-based-scholarships.amount',
    defaultMessage: 'AMOUNT',
  },
  gpa: {
    id: 'hubs.costs.merit-based-scholarships.gpa',
    defaultMessage: 'GPA',
  },
  sat: {
    id: 'hubs.costs.merit-based-scholarships.sat',
    defaultMessage: 'SAT',
  },
  act: {
    id: 'hubs.costs.merit-based-scholarships.act',
    defaultMessage: 'ACT',
  },
  classRank: {
    id: 'hubs.costs.merit-based-scholarships.class-rank',
    defaultMessage: 'CLASS RANK',
  },
  location: {
    id: 'hubs.costs.merit-based-scholarships.location',
    defaultMessage: 'Some amounts may reflect residency in ',
  },
  additionalInfo: {
    id: 'hubs.costs.merit-based-scholarships.additional-info',
    defaultMessage: 'Additional information for this institution: ',
  },
  disclaimer: {
    id: 'hubs.costs.merit-based-scholarships.disclaimer',
    defaultMessage:
      'These merit-based scholarships are based on amounts provided by the institution as of {date}, and could vary based on year of attendance.',
  },
  classRankTooltip: {
    id: 'hubs.costs.merit-based-scholarships.class-rank-tooltip',
    defaultMessage: `A measure comparing your academic performance to others in your class. For example, if you rank in the top 25% of your class, your GPA is higher than 75% of your classmates.`,
  },
  gpaTooltip: {
    id: 'hubs.costs.merit-based-scholarships.gpa-tooltip',
    defaultMessage: `If your school uses a GPA scale that is different than the standard scale at most colleges, below are instructions for converting your GPA to a 4.0 scale:`,
  },
});

export const classRankTooltip = (
  <div>
    <b>Class Rank</b>
    <br />
    <span>
      <FormattedMessage {...messages.classRankTooltip} />
    </span>
  </div>
);

export const gpaTooltip = (
  <div>
    <br />
    <FormattedMessage {...messages.gpaTooltip} />
    <table>
      <thead>
        <tr>
          <th>Letter Grade</th>
          <th>Percent Grade</th>
          <th>4.0 Scale</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>A+</td>
          <td>97</td>
          <td>4</td>
        </tr>
        <tr>
          <td>A</td>
          <td>94</td>
          <td>4</td>
        </tr>
        <tr>
          <td>A-</td>
          <td>90</td>
          <td>3.7</td>
        </tr>
        <tr>
          <td>B+</td>
          <td>87</td>
          <td>3.3</td>
        </tr>
        <tr>
          <td>B</td>
          <td>84</td>
          <td>3</td>
        </tr>
        <tr>
          <td>B-</td>
          <td>80</td>
          <td>2.7</td>
        </tr>
        <tr>
          <td>C+</td>
          <td>77</td>
          <td>2.3</td>
        </tr>
        <tr>
          <td>C</td>
          <td>74</td>
          <td>2</td>
        </tr>
        <tr>
          <td>C-</td>
          <td>70</td>
          <td>1.7</td>
        </tr>
        <tr>
          <td>D+</td>
          <td>67</td>
          <td>1.3</td>
        </tr>
        <tr>
          <td>D</td>
          <td>64</td>
          <td>1</td>
        </tr>
        <tr>
          <td>E/F</td>
          <td>60</td>
          <td>0</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default messages;
